'use strict';

var _ = require('lodash');
var DemandAndPaxAggregationFactory = function DemandAndPaxAggregationFactory(DataAggregationFactory) {
  function DemandAndPaxAggregationFactory() {
    DataAggregationFactory.call(this, 'rom-analysis-demand-pax-mode', 'rom-demand-pax-actual-optimal');
  }
  DemandAndPaxAggregationFactory.prototype = Object.create(DataAggregationFactory.prototype);
  DemandAndPaxAggregationFactory.constructor = DemandAndPaxAggregationFactory;
  DemandAndPaxAggregationFactory.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  DemandAndPaxAggregationFactory.prototype.aggregate = function (data, metricKeys) {
    var results = [];
    var foundRanges = [];
    _.forEach(data, function (record) {
      if (metricKeys.indexOf(record.bookType.toLocaleLowerCase()) === -1) {
        return;
      }
      var range = record.daysToDeparture;
      var mapIndex = _.findIndex(results, {
        'departureDate': record.departureDate,
        'class': record["class"],
        'service': record.service
      });
      if (mapIndex === -1) {
        var element = _.clone(record);
        element['actPax' + range] = element.actPax;
        element['optPax' + range] = element.optPax;
        element['demand' + range] = element.demand;
        element['netContribution' + range] = {
          netContribution: element.netContribution * element.demand,
          demand: element.demand
        };
        element['fare' + range] = {
          fare: element.fare * element.demand,
          demand: element.demand
        };
        results.push(element);
        if (foundRanges.indexOf(range) === -1) {
          foundRanges.push(range);
        }
      } else {
        if (results[mapIndex]['netContribution' + range] === undefined) {
          results[mapIndex]['netContribution' + range] = {
            netContribution: record.netContribution * record.demand,
            demand: record.demand
          };
        } else {
          results[mapIndex]['netContribution' + range].netContribution = _.add(results[mapIndex]['netContribution' + range].netContribution, record.netContribution * record.demand);
          results[mapIndex]['netContribution' + range].demand = _.add(results[mapIndex]['netContribution' + range].demand, record.demand);
        }
        if (results[mapIndex]['fare' + range] === undefined) {
          results[mapIndex]['fare' + range] = {
            fare: record.fare * record.demand,
            demand: record.demand
          };
        } else {
          results[mapIndex]['fare' + range].fare = _.add(results[mapIndex]['fare' + range].fare, record.fare * record.demand);
          results[mapIndex]['fare' + range].demand = _.add(results[mapIndex]['fare' + range].demand, record.demand);
        }
        results[mapIndex]['actPax' + range] = _.add(results[mapIndex]['actPax' + range], record.actPax);
        results[mapIndex]['optPax' + range] = _.add(results[mapIndex]['optPax' + range], record.optPax);
        results[mapIndex]['demand' + range] = _.add(results[mapIndex]['demand' + range], record.demand);
      }
    });
    results = results.map(function (element) {
      var keys = Object.getOwnPropertyNames(element);
      var i = 0,
        k = keys.length;
      for (; i < k; i++) {
        if (/fare\d+-\d+/.test(keys[i])) {
          element[keys[i]] = element[keys[i]].fare / element[keys[i]].demand;
        }
        if (/netContribution\d+-\d+/.test(keys[i])) {
          element[keys[i]] = element[keys[i]].netContribution / element[keys[i]].demand;
        }
      }
      delete element.daysToDeparture;
      delete element.actPax;
      delete element.optPax;
      delete element.demand;
      delete element.fare;
      delete element.netContribution;
      return element;
    });
    for (var index = 0, rangesLength = foundRanges.length; index < rangesLength; index++) {
      var range = foundRanges[index];
      if (results[0]['actPax' + range] === undefined) {
        results[0]['actPax' + range] = null;
      }
      if (results[0]['demand' + range] === undefined) {
        results[0]['demand' + range] = null;
      }
      if (results[0]['fare' + range] === undefined) {
        results[0]['fare' + range] = null;
      }
      if (results[0]['netContribution' + range] === undefined) {
        results[0]['netContribution' + range] = null;
      }
      if (results[0]['optPax' + range] === undefined) {
        results[0]['optPax' + range] = null;
      }
    }
    return results;
  };
  return DemandAndPaxAggregationFactory;
};
DemandAndPaxAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory'];
module.exports = DemandAndPaxAggregationFactory;